import Icons from "../../assets/icon/index";
import { fontSizes } from "../../constants/constants";
import { Button, FormInput, Newlogo, Text } from "../../components";
import Functions from "./index.funciton";
const ResetPassword = () => {
  const {
    TextWeight,
    handleSubmit,
    onSubmit,
    control,
    errors,
    getValues,
    loading,
  } = Functions();
  return (
    <div className="bg-primary scroll-container h-screen">
      <div className="sm:py-5 lg:py-10 max-w-7xl lg:px-5 xl:px-10 sm:px-5 xs:px-3 m-auto">
        <div className="flex justify-center items-center xs:py-5">
          <Newlogo />
        </div>
        <Text
          text={"Reset Password"}
          size={fontSizes.h30}
          isCenter={true}
          isTruncate={false}
          weight={TextWeight.Unbounded_bold}
          color="text-secondary"
          className={"sm:py-3"}
        />
      </div>
      <div className="max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <form
          className="flex justify-center items-center flex-col"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="relative mt-7 sm:w-[60%] xs:w-full lg:w-[50%]">
            <Text
              text={"Enter New Password"}
              size={fontSizes.h14}
              weight={TextWeight.Montserrat_light}
              color="text-secondary mb-5 sm:mb-7 lg:mb-10 xs:pl-7 sm:pl-6 lg:pl-7"
            />
            <FormInput
              control={control}
              userData={""}
              label="Password"
              type="password"
              name="password"
              placeholder="Password"
              isPassword={true}
              isMandatory={true}
              iconPasswordVisible={Icons.showPasswordIcon}
              iconPasswordHidden={Icons.hidePasswordIcon}
              iconStyle={"xs:w-5 xs:h-5 sm:w-5 sm:h-5 h-6 w-7 3xl:w-8 3xl:h-7"}
              // maxLength={30}
              pattern={{
                value: /^(?=.*[A-Z])(?=.*\d).{8,}$/,
                // message:
                //   "Password must be at least 8 characters long, contain at least 1 uppercase letter and 1 number",
              }}
              errors={errors}
            />
          </div>
          <div className="relative mt-7 sm:w-[60%] xs:w-full lg:w-[50%]">
            <FormInput
              control={control}
              userData={""}
              label="Confirm Password"
              type="password"
              name="confirmPassword"
              isPassword={true}
              iconPasswordVisible={Icons.showPasswordIcon}
              iconPasswordHidden={Icons.hidePasswordIcon}
              iconStyle={"xs:w-5 xs:h-5 sm:w-5 sm:h-5 h-6 w-7 3xl:w-8 3xl:h-7"}
              validate={(value) =>
                value === getValues("password") || "Passwords do not match"
              }
              errors={errors}
              isMandatory={true}
            />
          </div>
          <div
            className={
              "flex xs:flex-col sm:w-[60%] xs:w-full lg:w-[50%] pl-6 sm:pl-6 lg:pl-8"
            }
          >
            <Text
              text="Password must be at least 8 characters long, contain at least 1 uppercase letter and 1 number"
              size={fontSizes.h14}
              color="text-secondary"
              align="text-left"
              weight={TextWeight.Onest_regular}
              isTruncate={false}
            />
          </div>
          <Button
            text="Submit"
            type={"submit"}
            bgColor="gradient-container_btn"
            color="text-secondary"
            className="w-56 h-10 sm:w-60 sm:h-12 lg:w-64 lg:h-12 my-5"
            textSize={fontSizes.h16}
            weight={TextWeight.Onest_semiBold}
            loading={loading}
            isDisabled={loading}
          />
        </form>
      </div>
    </div>
  );
};
export default ResetPassword;
